import { render, staticRenderFns } from "./mobilehome.vue?vue&type=template&id=18d887c8&scoped=true"
import script from "./mobilehome.vue?vue&type=script&lang=js"
export * from "./mobilehome.vue?vue&type=script&lang=js"
import style0 from "./mobilehome.vue?vue&type=style&index=0&id=18d887c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d887c8",
  null
  
)

export default component.exports